import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';

import { useAuth } from '../../../shared/AuthContext';

const Component = () => {
  const { establishSession, isAuthenticated, loadingSession } = useAuth();
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  if (!loadingSession && isAuthenticated) {
    return <Navigate replace to="/dashboard" />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('Password confirmation does not match.');
      return;
    }
    setSaving(true);
    try {

      const Factory = require( '../../../records/auth' );

      const session = await Factory.bootstrapAdmin({
        fullName: form.fullName.trim(),
        email: form.email.trim(),
        password: form.password,
      });
      establishSession(session);
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'Unable to bootstrap admin user.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="auth-shell">
      <form className="card auth-card stack" onSubmit={handleSubmit}>
        <div className="stack-sm">
          <h1 className="page-title">Bootstrap first admin</h1>
          <p className="page-subtitle">Use this once to initialize the first admin account.</p>
        </div>

        {error ? <p className="error-text">{error}</p> : null}

        <label>
          Full name
          <input
            value={form.fullName}
            onChange={(event) => setForm((prev) => ({ ...prev, fullName: event.target.value }))}
          />
        </label>
        <label>
          Email
          <input
            autoComplete="email"
            type="email"
            value={form.email}
            onChange={(event) => setForm((prev) => ({ ...prev, email: event.target.value }))}
            required
          />
        </label>
        <label>
          Password
          <input
            autoComplete="new-password"
            type="password"
            value={form.password}
            onChange={(event) => setForm((prev) => ({ ...prev, password: event.target.value }))}
            required
          />
        </label>
        <label>
          Confirm password
          <input
            autoComplete="new-password"
            type="password"
            value={form.confirmPassword}
            onChange={(event) => setForm((prev) => ({ ...prev, confirmPassword: event.target.value }))}
            required
          />
        </label>

        <button className="button-primary" disabled={saving} type="submit">
          {saving ? 'Creating...' : 'Create admin account'}
        </button>

        <Link className="inline-link" to="/login">Back to sign in</Link>
      </form>
    </div>
  );
};

export default Component;
